import Manual from './Manual';

export default Manual;
